import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Divider, Grid, IconButton, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CrossIcon, InfoCircleNew } from '../../../assets/images';
import { MuiIconButton } from '../../../builderPackage/components';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { MuiPopup, MuiStack } from '../../../components';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
// import { getLocationDetailsAPICall, getSerialNoDetails } from '../services/apiCalls'
import { SpareIssueReturnKeys, SpareIssueReturnStatusEnum } from '../services/entity';
// import IssueQuantityCell from './issueQuantityCell'
// import LocationDetailCell from './locationDetailcell'
// import { LocationMultiSelectPopUp } from './locationMultiSelectPopup'
// import { MultiSelectPopUp } from './multiSelectPopUp'
import LocationDetailCell from '../../spareIssue/components/locationDetailcell';
import { LocationMultiSelectPopUp } from '../../spareIssue/components/locationMultiSelectPopup';
import { SerialNumberSelect } from '../../spareIssue/components/serialNumberselect';
var PartDetails = function (props) {
    var _crud$SpareIssueRetur, _crud$SpareIssueRetur2, _crud$SpareIssueRetur3, _crud$SpareIssueRetur6, _crud$SpareIssueRetur9;
    var onChange = props.onChange, value = props.value, _a = props.name, name = _a === void 0 ? 'partsDetailsList' : _a;
    console.log("value", value);
    var _b = useState(false), isSearchBoxVisible = _b[0], setIsSearchBoxVisible = _b[1];
    var _c = useState(''), searchValue = _c[0], setSearchValue = _c[1];
    var _d = useState(false), isSingleSelection = _d[0], setIsSingleSelection = _d[1];
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _e = useState(), modalProps = _e[0], setModalProps = _e[1];
    var _f = useState(), locationModalProps = _f[0], setLocationModalProps = _f[1];
    var _g = useState([]), matchedIds = _g[0], setMatchedIds = _g[1];
    var _h = useState(), issueQty = _h[0], setIssueQty = _h[1];
    var isMulitpleDoc = getLocalStorageItem(LOCAL_STORAGE_KEYS.SPARE_ISSUE_MULTIPLE_DOC);
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var data = (_crud$SpareIssueRetur = (_crud$SpareIssueRetur2 = crud[SpareIssueReturnKeys.JobcardDetails]) === null || _crud$SpareIssueRetur2 === void 0 ? void 0 : _crud$SpareIssueRetur2.data) !== null && _crud$SpareIssueRetur !== void 0 ? _crud$SpareIssueRetur : (_crud$SpareIssueRetur3 = crud[SpareIssueReturnKeys.SpareIssueDetails]) === null || _crud$SpareIssueRetur3 === void 0 ? void 0 : _crud$SpareIssueRetur3.data;
    var isDisable = isMulitpleDoc && mode == 'edit' || data == SpareIssueReturnStatusEnum.Issued || data == SpareIssueReturnStatusEnum.PartiallyReturned || data == SpareIssueReturnStatusEnum.Returned || data == SpareIssueReturnStatusEnum.Cancelled || data == SpareIssueReturnStatusEnum.Closed;
    var dispatch = useAppDispatch();
    useEffect(function () {
        var _crud$SpareIssueRetur4, _crud$SpareIssueRetur5;
        if ((_crud$SpareIssueRetur4 = crud[SpareIssueReturnKeys.PartDetails]) !== null && _crud$SpareIssueRetur4 !== void 0 && _crud$SpareIssueRetur4.data && onChange)
            onChange(null, (_crud$SpareIssueRetur5 = crud[SpareIssueReturnKeys.PartDetails]) === null || _crud$SpareIssueRetur5 === void 0 ? void 0 : _crud$SpareIssueRetur5.data);
    }, [(_crud$SpareIssueRetur6 = crud[SpareIssueReturnKeys.PartDetails]) === null || _crud$SpareIssueRetur6 === void 0 ? void 0 : _crud$SpareIssueRetur6.data]);
    useEffect(function () {
        var _crud$SpareIssueRetur7, _crud$SpareIssueRetur8;
        if ((_crud$SpareIssueRetur7 = crud[SpareIssueReturnKeys.SpareIssueDetails]) !== null && _crud$SpareIssueRetur7 !== void 0 && _crud$SpareIssueRetur7.data && onChange)
            onChange(null, (_crud$SpareIssueRetur8 = crud[SpareIssueReturnKeys.SpareIssueDetails]) === null || _crud$SpareIssueRetur8 === void 0 || (_crud$SpareIssueRetur8 = _crud$SpareIssueRetur8.data) === null || _crud$SpareIssueRetur8 === void 0 ? void 0 : _crud$SpareIssueRetur8.ProductIssueDetails);
    }, [(_crud$SpareIssueRetur9 = crud[SpareIssueReturnKeys.SpareIssueDetails]) === null || _crud$SpareIssueRetur9 === void 0 || (_crud$SpareIssueRetur9 = _crud$SpareIssueRetur9.data) === null || _crud$SpareIssueRetur9 === void 0 ? void 0 : _crud$SpareIssueRetur9.ProductIssueDetails]);
    var columns = [{
            field: 'ProductName',
            headerName: 'Part name & code',
            editable: true,
            flex: 1,
            width: 300,
            align: 'left',
            headerAlign: 'left',
            renderCell: function (params) {
                var _params$row, _params$row2, _params$row3, _params$row4, _params$row5, _params$row6, _params$row7;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    height: '100%'
                }, /*#__PURE__*/ React.createElement(MuiStack, {
                    flexDirection: 'column'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h5",
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#1B1D21'
                    }
                }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ProductName), /*#__PURE__*/ React.createElement(Typography, {
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#6A7682'
                    }
                }, params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.Code)), /*#__PURE__*/ React.createElement(MuiStack, null, params.hasFocus && /*#__PURE__*/ React.createElement(Tooltip, {
                    title: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
                        key: params.id,
                        direction: 'column',
                        width: '379px',
                        bgcolor: 'white',
                        borderRadius: '8px',
                        marginTop: "20px",
                        boxShadow: '0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)'
                    }, /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'row',
                        width: '100%',
                        padding: "15px",
                        bgcolor: '#F4F7FA',
                        justifyContent: "space-between",
                        borderRadius: '8px'
                    }, /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "h3",
                        color: '#1B1D21',
                        whiteSpace: 'wrap'
                    }, params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ChildName), /*#__PURE__*/ React.createElement(Typography, {
                        variant: "h6",
                        color: '#6A7682'
                    }, params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.Code)), /*#__PURE__*/ React.createElement(IconButton, {
                        sx: {
                            padding: 0
                        }
                    }, /*#__PURE__*/ React.createElement("img", {
                        alt: "close-stepper-icon",
                        id: "close-stepper-button",
                        src: CrossIcon
                    }))), /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column',
                        width: '80%',
                        bgcolor: '#FFFFFF',
                        borderRadius: '8px'
                    }, /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'row',
                        padding: "15px",
                        justifyContent: "space-between"
                    }, /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "h6",
                        color: '#8593A3'
                    }, t('Part type')), /*#__PURE__*/ React.createElement(Typography, {
                        variant: "h4",
                        color: '#1B1D21',
                        id: "partType"
                    }, params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 || (_params$row5 = _params$row5.PriceDetail) === null || _params$row5 === void 0 ? void 0 : _params$row5.Type)), /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "h6",
                        color: '#8593A3'
                    }, t('HSN code')), /*#__PURE__*/ React.createElement(Typography, {
                        variant: "h4",
                        color: '#1B1D21',
                        id: "hsnCode"
                    }, params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.HSNCode))), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'row',
                        width: '100%',
                        padding: "15px",
                        justifyContent: "space-between"
                    }, /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "h6",
                        color: '#8593A3'
                    }, t('M.R.P.()')), /*#__PURE__*/ React.createElement(Typography, {
                        variant: "h4",
                        color: '#1B1D21',
                        id: "price"
                    }, params === null || params === void 0 || (_params$row7 = params.row) === null || _params$row7 === void 0 || (_params$row7 = _params$row7.PriceDetail) === null || _params$row7 === void 0 ? void 0 : _params$row7.Price)))))),
                    arrow: true,
                    placement: "right",
                    slotProps: {
                        tooltip: {
                            sx: {
                                backgroundColor: "#ffff"
                            }
                        }
                    }
                }, /*#__PURE__*/ React.createElement(MuiIconButton, null, /*#__PURE__*/ React.createElement("img", {
                    id: "infoIconBtn",
                    src: InfoCircleNew
                })))));
            }
        }, {
            type: 'singleSelect',
            field: 'UnitOfMeasurementName',
            headerName: 'UOM',
            editable: false,
            flex: 1,
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'LocationDetails',
            headerName: 'Issued Location',
            editable: false,
            flex: 1,
            align: 'left',
            headerAlign: 'left',
            renderCell: function (params) {
                var handleLocationDetailSubmit = function (selectedRows, rows, rowData) {
                    var _value$name;
                    var row = params === null || params === void 0 ? void 0 : params.row;
                    var data = rows === null || rows === void 0 ? void 0 : rows.filter(function (item, index) { return (item === null || item === void 0 ? void 0 : item.id) == selectedRows; });
                    var newRows = (_value$name = value[name]) === null || _value$name === void 0 ? void 0 : _value$name.map(function (r) {
                        var _params$row8;
                        return (params === null || params === void 0 || (_params$row8 = params.row) === null || _params$row8 === void 0 ? void 0 : _params$row8.id) === (r === null || r === void 0 ? void 0 : r.id) ? _objectSpread(_objectSpread({}, r), {}, {
                            LocationDetails: data
                        }) : r;
                    });
                    if (onChange)
                        onChange(null, newRows);
                    setLocationModalProps(undefined);
                };
                var handleLocationDetailClick = function (e) {
                    var _params$row9, _params$row10;
                    var locationModalProps = {
                        selectedRows: params === null || params === void 0 || (_params$row9 = params.row) === null || _params$row9 === void 0 || (_params$row9 = _params$row9.LocationDetails[0]) === null || _params$row9 === void 0 ? void 0 : _params$row9.id,
                        onSubmit: handleLocationDetailSubmit,
                        apiRequest: {
                            TenantId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                            ProductId: params === null || params === void 0 || (_params$row10 = params.row) === null || _params$row10 === void 0 ? void 0 : _params$row10.ChildId,
                            WarehouseId: value === null || value === void 0 ? void 0 : value.WarehouseId
                        },
                        // apiCall: getLocationDetailsAPICall,
                        apiKey: SpareIssueReturnKeys === null || SpareIssueReturnKeys === void 0 ? void 0 : SpareIssueReturnKeys.LocationDetails,
                        columns: locationColumns,
                        title: t('Location Details'),
                        rowData: params.row
                    };
                    setLocationModalProps(locationModalProps);
                    setIsSearchBoxVisible(false);
                    setIsSingleSelection(true);
                };
                return /*#__PURE__*/ React.createElement(LocationDetailCell, _extends({}, params, {
                    modalProps: locationModalProps,
                    onClick: handleLocationDetailClick
                }));
            }
        }, {
            field: 'IssuedQuantity',
            headerName: 'Issued Qty',
            editable: false,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'PreviousReturnQty',
            headerName: 'Previous return qty',
            editable: false,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'AvailableQtyForReturn',
            headerName: 'Available qty for return',
            editable: false,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'ReturnQty',
            headerName: 'Return Qty',
            editable: false,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'PurchaseCost',
            headerName: 'Purchase cost (₹)',
            editable: false,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'TotalCost',
            headerName: 'Total Cost',
            editable: false,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'Reasom',
            headerName: 'Reason',
            editable: false,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'Remarks',
            headerName: 'Remarks',
            editable: false,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }];
    var locationColumns = [{
            field: 'LocationName',
            headerName: 'Location Name',
            editable: false,
            flex: 1
        }, {
            field: 'QuantityAvailable',
            headerName: 'Available Qty.',
            editable: false,
            flex: 1
        }, {
            field: 'IssueQuantity',
            headerName: 'Issue Qty',
            editable: true,
            flex: 1,
            renderCell: function (params) {
                var _params$row12;
                if ((params === null || params === void 0 ? void 0 : params.value) > 0) {
                    var _value$name2;
                    setIssueQty(params === null || params === void 0 ? void 0 : params.value);
                    (_value$name2 = value[name]) === null || _value$name2 === void 0 || _value$name2.map(function (r) {
                        var _params$row11;
                        return (params === null || params === void 0 || (_params$row11 = params.row) === null || _params$row11 === void 0 ? void 0 : _params$row11.id) === (r === null || r === void 0 ? void 0 : r.id) ? _objectSpread(_objectSpread({}, r), {}, {
                            IssueQuantity: issueQty
                        }) : r;
                    });
                }
                return /*#__PURE__*/ React.createElement(Typography, null, params === null || params === void 0 || (_params$row12 = params.row) === null || _params$row12 === void 0 ? void 0 : _params$row12.IssueQuantity);
            }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: value[name],
        onChange: onChange,
        dataGridHeader: 'Part details',
        disableAddRow: true,
        disableDeleteRow: true,
        dataGridProps: {
            disableColumnSorting: true,
            disableColumnMenu: false,
            onCellKeyDown: function (params, e) {
                if (e.key === 'Enter')
                    e.preventDefault();
            },
            isCellEditable: function (params) {
                var _params$row13;
                return isDisable ? !isDisable : (params === null || params === void 0 || (_params$row13 = params.row) === null || _params$row13 === void 0 ? void 0 : _params$row13.StatusName) !== SpareIssueReturnStatusEnum.Issued;
            },
            sx: {
                borderRadius: '12px !important'
            }
        },
        validationModel: {
            IssueQuantity: function (value, row) {
                var _row$RequestedQuantit, _row$AvailableQuantit;
                var updatedReqQty = (row === null || row === void 0 ? void 0 : row.RequestedQuantity) - (row === null || row === void 0 ? void 0 : row.IssuedQuantity);
                return value > ((_row$RequestedQuantit = row === null || row === void 0 ? void 0 : row.RequestedQuantity) !== null && _row$RequestedQuantit !== void 0 ? _row$RequestedQuantit : 0) ? "Issue quantity cannot be more than requested quantity." : value > ((_row$AvailableQuantit = row === null || row === void 0 ? void 0 : row.AvailableQuantity) !== null && _row$AvailableQuantit !== void 0 ? _row$AvailableQuantit : 0) ? "Available quantity is lesser than issue quantity." : value > updatedReqQty ? "Issue quantity cannot be more than pending quantity." : "";
            }
        }
    })), /*#__PURE__*/ React.createElement(MuiPopup, {
        id: "part-serialno-popup",
        variant: "h1",
        openPopup: Boolean(modalProps),
        onClose: function () {
            setModalProps(undefined);
        },
        closeIcon: isSearchBoxVisible !== null && isSearchBoxVisible !== void 0 ? isSearchBoxVisible : false,
        title: modalProps === null || modalProps === void 0 ? void 0 : modalProps.title,
        searchBox: isSearchBoxVisible !== null && isSearchBoxVisible !== void 0 ? isSearchBoxVisible : false,
        onSearchChange: function (value) { return setSearchValue(value); },
        subTitleStyle: {
            marginTop: "10px",
            color: "#8593A3"
        },
        backdropEnable: false,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            width: lgMode ? '500px' : 'calc(90vw)',
            paddingTop: 0,
            paddingX: "16px"
        }
    }, modalProps && /*#__PURE__*/ React.createElement(SerialNumberSelect, _extends({}, modalProps, {
        onClose: function () { return setModalProps(undefined); },
        singleSelection: isSingleSelection,
        issueQuantity: issueQty,
        searchValue: searchValue
    }))), locationModalProps && /*#__PURE__*/ React.createElement(MuiPopup, {
        id: "part-location-popup",
        variant: "h1",
        openPopup: Boolean(locationModalProps),
        onClose: function () {
            setLocationModalProps(undefined);
        },
        closeIcon: isSearchBoxVisible !== null && isSearchBoxVisible !== void 0 ? isSearchBoxVisible : false,
        title: locationModalProps === null || locationModalProps === void 0 ? void 0 : locationModalProps.title,
        searchBox: isSearchBoxVisible !== null && isSearchBoxVisible !== void 0 ? isSearchBoxVisible : false,
        onSearchChange: function (value) { return setSearchValue(value); },
        subTitleStyle: {
            marginTop: "10px",
            color: "#8593A3"
        },
        backdropEnable: false,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            width: lgMode ? '500px' : 'calc(90vw)',
            paddingTop: 0,
            paddingX: "16px"
        }
    }, locationModalProps && /*#__PURE__*/ React.createElement(LocationMultiSelectPopUp, _extends({}, locationModalProps, {
        onClose: function () { return setLocationModalProps(undefined); },
        singleSelection: isSingleSelection,
        issueQuantity: issueQty,
        searchValue: searchValue
    }))));
};
export default PartDetails;
